import { render } from "./VerticalSwiper.vue?vue&type=template&id=befc8d5e&scoped=true"
import script from "./VerticalSwiper.vue?vue&type=script&lang=js"
export * from "./VerticalSwiper.vue?vue&type=script&lang=js"

import "./VerticalSwiper.vue?vue&type=style&index=0&id=befc8d5e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befc8d5e"]])

export default __exports__